// Må samsvare med regexen i backend/students/serializers.py
export const PASSWORD_PATTERN = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;
export const PASSWORD_MESSAGE = "Passordet må være minst 8 tegn langt med minst én stor bokstav og ett tall";
export const PASSWORD_RULE = { pattern: PASSWORD_PATTERN, message: PASSWORD_MESSAGE };
// Backend sier "symbol" i teksten, men sjekker egentlig for tall
export const BACKEND_PASSWORD_ERROR =
  "Password must be at least 8 characters long with at least one capital letter and symbol";
